export default __webpack_public_path__ + "76e5b29823c9fd62d90dc827ff41e4cb.svg";